export const disableUnnecessaryFields = () => {
    var addressSelected = 'Y';
    $.each($('input[name="ship-address-radio"]'), function() {
        if ($(this).prop('checked')) {
            if ($(this).prop('id') == "displaySavedAddressesRadio" || $(this).prop('id') == "displayRegistryAddressesRadio") {
                var savedIDBlank = document.getElementById("savedShippingAddressId").value == "",
                    registryIDBlank = document.getElementById("registryShippingAddressId").value == "";
                if (savedIDBlank || registryIDBlank) addressSelected = 'N';
            }
        }
    });
    if (addressSelected == 'Y') {
        $('input[name^="quantity_"]').prop('disabled', true);
        $('input[name^="shipmodeId_"]').prop('disabled', true);
        $('select[name^="selectShipModeId"]').prop('disabled', true);
        $('select[name^="selectShipaddressId"]').prop('disabled', true);
        $('input[name^="orderItemId_"]').prop('disabled', true);
    };
};
